import { Checkbox, Slider } from 'antd';
import { __PostsFilterItemPropsType } from 'aloEjare/posts/posts.type';
import { CategoryFieldTypeEnum } from 'types';

export default function PostsFilterItemComp({ item, activeFilters, setActiveFilters }: __PostsFilterItemPropsType) {
    const value = activeFilters.ranges?.find((i) => i.id === item.id)?.value;
    const extractField = (field: string) => {
        if (item.setting && Object.hasOwn(item.setting, field)) return Number(item.setting[field]);
    };

    const changeCategoryFields = (e: number[]) => {
        setActiveFilters({
            ...activeFilters,
            categoryFields:
                activeFilters.categoryFields?.length && activeFilters.categoryFields[0].id === item.id
                    ? activeFilters.categoryFields
                          .filter((i) => i.id !== item.id)
                          .concat(e.map((i) => ({ id: item.id, value: i })))
                    : e.map((i) => ({ id: item.id, value: i })),
        });
    };

    return item.type === CategoryFieldTypeEnum.boolean ? (
        <Checkbox
            checked={activeFilters.categoryFields?.find((i) => i.id === item.id)?.value === 1}
            onChange={(e) =>
                setActiveFilters({
                    ...activeFilters,
                    categoryFields: activeFilters.categoryFields
                        ? activeFilters.categoryFields
                              .filter((i) => i.id !== item.id)
                              .concat({
                                  id: item.id,
                                  value: e.target.checked ? 1 : 0,
                              })
                        : [{ id: item.id, value: e.target.checked ? 1 : 0 }],
                })
            }
        >
            {item.title}
        </Checkbox>
    ) : item.type === CategoryFieldTypeEnum.number ? (
        <Slider
            range
            min={extractField('min') ?? 1}
            max={extractField('max') ?? 100}
            step={extractField('step')}
            defaultValue={value ?? [extractField('min') ?? 1, extractField('max') ?? 100]}
            value={value}
            tooltip={{ formatter: (v) => `${v} ${item.unit}` }}
            onChange={(e) =>
                setActiveFilters({
                    ...activeFilters,
                    ranges: activeFilters.ranges
                        ? activeFilters.ranges
                              .filter((i) => i.id !== item.id)
                              .concat({ id: item.id, value: [e[0], e[1]] })
                        : [{ id: item.id, value: [e[0], e[1]] }],
                })
            }
        />
    ) : item.type === CategoryFieldTypeEnum.fieldOptions ? (
        <Checkbox.Group
            options={item.field_options?.map((i) => ({
                label: i.title,
                value: i.id,
            }))}
            className="flex-column g-2 m-0-i"
            onChange={changeCategoryFields}
            value={activeFilters.categoryFields?.filter((i) => i.id === item.id).map((i) => i.value)}
        />
    ) : null;
}
